import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="video-preview"
export default class extends Controller {
  static targets = ["input", "preview", "icon"];

  readURL() {
    const input = this.inputTarget;

    if (input.files && input.files[0]) {
      const file = input.files[0];

      // Safety check to ensure it's actually a video
      if (!file.type.startsWith("video/")) {
        alert("Please select a valid video file.");
        return;
      }

      // Create a fast, memory-safe object URL instead of a Base64 string
      const videoURL = URL.createObjectURL(file);

      this.previewTarget.src = videoURL;
      this.previewTarget.classList.remove("hidden");

      // Hide the placeholder icon
      if (this.hasIconTarget) {
        this.iconTarget.classList.add("hidden");
      }

      // Clean up the object URL from the browser's memory once it loads
      this.previewTarget.onloadeddata = () => {
        URL.revokeObjectURL(this.previewTarget.src);
      };
    }
  }
}
